import { KEEP_ALIVE_OBJECT } from '@/common/constants/ConstCode';
import store from '@/store';
import { isEmpty } from '@/common/utils/Util';
import router from '@/router';

export default [
  {
    path: '/oauth/kakao/callback',
    component: () => import('@/views/user/KakaoCallback.vue'),
    meta: {
      isHeader: false,
      isNav: false,
      isBack: false
    }
  },
  {
    path: '/oauth/naver/callback',
    component: () => import('@/views/user/NaverCallback.vue'),
    meta: {
      isHeader: false,
      isNav: false,
      isBack: false
    }
  },
  {
    path: '/signIn',
    // 260521: 코드 곳곳에서 router.push('/signin') 소문자로 호출 → 케이스 미스매치로
    //   history에 /signin 박힐 때 layout 가드가 stale 동작하던 사례 방지용 명시 alias
    alias: ['/signin'],
    component: () => import('@/views/user/signIn'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isGlass: true,
      titleName: '로그인 또는 회원가입'
    },
    beforeEnter: async function(to, from, next) {
      const userData = store.getters['user/getUserData'];

      if (!isEmpty(userData.userNo)) {
        // 260521 호크룩스: /signin → /main 자동 redirect 시 history에 /signin 안 박히게 replace
        next({ path: '/main', replace: true });
      } else {
        next();
      }
    }
  },
  {
    path: '/signOut',
    component: () => import('@/views/main/Main.vue'),
    meta: {
      isHeader: false,
      isNav: false,
      isBack: false,
      titleName: '로그아웃'
    },
    beforeEnter: async function(to, from, next) {
      await store.dispatch('user/signOut');
      router.push('/');
    }
  },
  {
    path: '/signup',
    component: () => import('@/views/user/singup/SignUp.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '회원가입',
      expression: KEEP_ALIVE_OBJECT.SIGNUP.expression
    }
  },
  {
    // 260630 C: 가입 직후 1회 관심사 설문(취향). 뒤로가기 막고(back X) 건너뛰기/완료로만 이탈.
    path: '/interest-survey',
    component: () => import('@/views/user/singup/ConsumerInterestSurvey.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: false,
      titleName: '관심사 알려주기'
    }
  },
  {
    path: '/signup/premium',
    component: () => import('@/views/user/singup/SignUpPremium.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '프리미엄 회원 쿠폰 인증',
      expression: KEEP_ALIVE_OBJECT.SIGNUP.expression,
      isHome: true
    }
  },
  {
    path: '/change/premium',
    component: () => import('@/views/user/singup/ChangePremium.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '프리미엄 회원 쿠폰 등록',
      isHome: true
    }
  },
  {
    path: '/signup/terms',
    component: () => import('@/views/terms/serviceTerms.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '서비스 이용약관',
      expression: KEEP_ALIVE_OBJECT.SIGNUP.expression
    }
  },
  {
    path: '/find/id',
    component: () => import('@/views/user/find/id/id.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      titleName: 'ID 찾기',
      expression: KEEP_ALIVE_OBJECT.FIND_ID.expression
    }
  },
  {
    path: '/find/id/result',
    component: () => import('@/views/user/find/id/idStep2.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      titleName: 'ID 찾기',
      expression: KEEP_ALIVE_OBJECT.FIND_ID.expression
    }
  },
  {
    path: '/find/password',
    component: () => import('@/views/user/find/password/password.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      titleName: '비밀번호 찾기',
      expression: KEEP_ALIVE_OBJECT.FIND_PASS.expression
    }
  },
  {
    path: '/find/password/auth',
    component: () => import('@/views/user/find/password/passwordStep2.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      titleName: '비밀번호 찾기',
      expression: KEEP_ALIVE_OBJECT.FIND_PASS.expression
    }
  },
  {
    path: '/find/password/result',
    component: () => import('@/views/user/find/password/passwordStep3.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      titleName: '비밀번호 찾기',
      expression: KEEP_ALIVE_OBJECT.FIND_PASS.expression
    }
  },
  {
    path: '/setting/welldying/password',
    component: () => import('@/views/user/SetupWellPassword.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '웰다잉 비밀번호 설정'
    }
  }
];
